// HomeTag.js
// Small pill-shaped status label. Tone maps to a text/background pair from
// homeTheme: bad -> red, warn -> amber, ok -> green, info -> brand.
import React from "react";
import { Text, StyleSheet } from "react-native";

import { homeColors } from "../homeTheme";

const TONE_KEYS = {
  bad: { text: "red", bg: "redSoft" },
  warn: { text: "amber", bg: "amberSoft" },
  ok: { text: "green", bg: "greenSoft" },
  info: { text: "brand", bg: "brandSoft" },
};

const HomeTag = ({ label, tone = "info", isDarkMode = false }) => {
  const colors = homeColors(isDarkMode);
  const keys = TONE_KEYS[tone] || TONE_KEYS.info;

  return (
    <Text
      style={[
        styles.tag,
        { color: colors[keys.text], backgroundColor: colors[keys.bg] },
      ]}
      numberOfLines={1}
      ellipsizeMode="tail"
    >
      {label}
    </Text>
  );
};

const styles = StyleSheet.create({
  tag: {
    minHeight: 22,
    lineHeight: 22,
    borderRadius: 6,
    paddingHorizontal: 8,
    fontSize: 11.5,
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: 0.3,
    flexShrink: 1,
  },
});

export default HomeTag;
